import { Colors, Lightning } from '@lightningjs/sdk'

export default class Equalizer extends Lightning.Component {
  static _template() {
    return {
      Bar1: {
        w: 10,
        h: 46,
        x: 5,
        y: 46,
        mountY: 1,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 5,
          stroke: 2,
          strokeColor: Colors('lBlue').get(),
          fill: 0,
          fillColor: 0x00000000,
        },
      },
      Bar2: {
        w: 10,
        h: 30,
        x: 17,
        y: 46,
        mountY: 1,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 5,
          stroke: 2,
          strokeColor: Colors('lBlue').get(),
          fill: 0,
          fillColor: 0x00000000,
        },
      },
      Bar3: {
        w: 10,
        h: 28,
        x: 29,
        y: 46,
        mountY: 1,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 5,
          stroke: 2,
          strokeColor: Colors('lBlue').get(),
          fill: 0,
          fillColor: 0x00000000,
        },
      },
    }
  }

  _init() {
    this._EqAnimation = this.animation({
      duration: 2.5,
      repeat: -1,
      actions: [
        {
          t: 'Bar1',
          p: 'h',
          v: {
            sm: 0,
            0: 40,
            0.083: 36,
            0.166: 28,
            0.249: 36,
            0.332: 40,
            0.415: 44,
            0.498: 36,
            0.581: 28,
            0.664: 24,
            0.747: 40,
            0.83: 36,
            0.913: 46,
            1: 44,
          },
        },
        {
          t: 'Bar2',
          p: 'h',
          v: {
            sm: 0,
            0: 20,
            0.083: 24,
            0.166: 24,
            0.249: 30,
            0.332: 32,
            0.415: 40,
            0.498: 44,
            0.581: 46,
            0.664: 40,
            0.747: 30,
            0.83: 36,
            0.913: 28,
            1: 20,
          },
        },
        {
          t: 'Bar3',
          p: 'h',
          v: {
            sm: 0,
            0: 28,
            0.083: 36,
            0.166: 44,
            0.249: 40,
            0.332: 36,
            0.415: 24,
            0.498: 20,
            0.581: 16,
            0.664: 25,
            0.747: 32,
            0.83: 20,
            0.913: 20,
            1: 24,
          },
        },
      ],
    })
  }

  set barColor(colr) {
    this.patch({
      Bar1: { shader: { strokeColor: colr } },
      Bar2: { shader: { strokeColor: colr } },
      Bar3: { shader: { strokeColor: colr } },
    })
  }

  startAnimation() {
    this._EqAnimation.start()
  }

  stopAnimation() {
    if (this._EqAnimation) {
      this._EqAnimation.stop()
      this._EqAnimation.finish()
    }
  }
}
